import UnpaidReceiptsGrid from './UnpaidReceiptsGrid';

export default UnpaidReceiptsGrid;
